import { create } from "zustand";
import { devtools, persist } from "zustand/middleware";
import { userDTO } from "../types/types";
type UserState = {
  userData: userDTO & { role?: string };
  setUserData: (userData: Partial<userDTO & { role?: string }>) => void;
  reset: () => void;
};
export const useUserDataStore = create<UserState>()(
  devtools(
    persist(
      (set) => ({
        userData: {
          id: null,
          firstName: null,
          lastName: null,
          email: null,
          country: null,
          img_url: null,
          phone: null,
          lastCountry: null,
          birthDate: null,
          cartId: null,
          confirmPassword: null,
          createdAt: null,
          jobTitle: null,
          lastVisited: null,
          password: null,
          role: "", // Initialize role
        },
        setUserData: (userData) =>
          set((state) => ({
            ...state,
            userData: {
              ...state.userData,
              ...userData,
            },
          })),
        reset: () => {
          set(() => ({
            userData: {
              id: null,
              firstName: null,
              lastName: null,
              email: null,
              country: null,
              img_url: null,
              phone: null,
              lastCountry: null,
              birthDate: null,
              cartId: null,
              confirmPassword: null,
              createdAt: null,
              jobTitle: null,
              lastVisited: null,
              password: null,
              role: "",
            },
          }));
        },
      }),
      { name: "userStore" }
    )
  )
);
